// Canonical panel action definitions (WP-SE-34)
// Handlers are stubs until the implementing WPs land (WP-SE-36, 39, 40, 41, 42)

function stub(label) {
    return () => console.log(`[PanelAction] ${label} clicked`);
}

// Ready to Deploy panel
// onClick handlers are placeholders here; ReadyToDeployPanel (or its consumer)
// derives a new actions array with real handlers via Array.map, mirroring the
// pattern in StagingArea.js.
export const READY_TO_DEPLOY_ACTIONS = [
    { label: '+ New', onClick: stub('+ New'), requiresSelection: false },
    { label: 'Edit', onClick: stub('Edit'), requiresSelection: true },
    { label: 'Duplicate', onClick: stub('Duplicate'), requiresSelection: true },
    { label: 'Deploy', onClick: stub('Deploy'), requiresSelection: true, hideWhen: (state) => state.selectedSurvey?.status === 'deployed' },
    { label: 'Delete', onClick: stub('Delete'), requiresSelection: true },
    // Share: send a copy of the selected survey to another account.
    // Single-selection only.
    { label: 'Share', onClick: stub('Share'), requiresSelection: true, disabledWhen: (state) => state.multiCount > 1 },
    { label: 'Archive', onClick: stub('Archive'), requiresSelection: true, disabledWhen: (state) => !state.archiveFileOpen },
    // 'Load Archive' removed 2026-08-15 (verified dead in testing): its handler
    // never completed a load, and survey restoration deliberately lives in the
    // Accounts panel's Archive Manager (Reload flow via sam-dbam) so restoring
    // is an explicit, deliberate act by the Author.
];

// Deployed panel
// Edit intentionally absent (removed 2026-07-31): a deployed survey's version
// is pinned/immutable, so opening the Designer from here invited an edit the
// system must refuse (PINNED_VERSION_IMMUTABLE). Editing lives on the
// Ready-to-Deploy panel; this panel's actions are about the deployment itself.
export const DEPLOYED_ACTIONS = [
    // Custom: assign a custom URL slug to the selected deployment.
    // Single-selection only — a slug names exactly one deployment.
    { label: 'Custom', onClick: stub('Custom'), requiresSelection: true, disabledWhen: (state) => state.multiCount > 1 },
    { label: 'Undeploy', onClick: stub('Undeploy'), requiresSelection: true, hideWhen: (state) => state.selectedSurvey?.status !== 'deployed' },
];

// Survey Recipients panel
export const SURVEY_RECIPIENTS_ACTIONS = [
    { label: '+ Add', onClick: stub('+ Add'), requiresSelection: false },
    { label: 'Edit', onClick: stub('Edit'), requiresSelection: true },
    { label: 'Delete', onClick: stub('Delete'), requiresSelection: true },
    { label: 'Manage Tags', onClick: stub('Manage Tags'), requiresSelection: true },
];

// Dispatched Surveys panel (WP-SE-41, renamed 2026-05-18)
// Investigate is intentionally NOT in this list — double-click on a row opens the
// Explorer's Explore tab (primary affordance), and right-click → "Investigate in
// Explorer" is the discoverable alternative (see ExecutedSurveysPanel.menuItems).
export const EXECUTED_SURVEYS_ACTIONS = [
    { label: 'Re-deploy', onClick: stub('Re-deploy'), requiresSelection: true },
];

// Staging Area panel (WP-SE-39)
export const STAGING_AREA_ACTIONS = [
    { label: '+ Recipients', onClick: stub('+ Recipients'), requiresSelection: false },
    { label: 'Send', onClick: stub('Send'), requiresSelection: false, requiresLinkedSurvey: true, primary: true },
    { label: 'Clear', onClick: stub('Clear'), requiresSelection: false },
];

// Channel Status panel (WP-SE-42) - read-only, no actions
export const CHANNEL_STATUS_ACTIONS = [];
